import React, { useMemo } from 'react'
import { makeStyles, useTheme } from '@mui/styles'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import buildName from '@/modules/todo/components/_helpers/buildName'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import CloseIcon from '@assets/images/icons/close2.svg'
import EditIcon from '@assets/images/icons/pencil.svg'
import { MultiSelectItemObj } from '@/components/multi-select/types'
import { getMultiSelectItemInfoLabel } from '@/components/multi-select/helpers/getItemLabel'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  selectedItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme.backgroundColor,
    border: `1px solid ${theme.borderColors.default}`,
    borderRadius: 4,
    padding: '10px 16px',
  },
  selectedItemInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  selectedItemName: {
    fontSize: theme.fontSizes.small,
  },
  details: {
    fontSize: theme.fontSizes.extrasmall,
    color: theme.labelLight,
    marginTop: 5,
  },
  info: {
    borderRight: `1px solid ${theme.labelLight}`,
    paddingRight: 10,
    marginRight: 10,
  },
  actions: {
    display: 'flex',
    '& > :first-child': {
      marginRight: 15,
    },
  },
  icon: {
    cursor: 'pointer',
  },
}))

type MultiSelectActiveItemProps = {
  selectedItem?: MultiSelectItemObj,
  onReset: () => void,
  onEdit: () => void,
}

const MultiSelectActiveItem = (props: MultiSelectActiveItemProps) => {
  const classes = useStyles()
  const theme: ThemeInterface = useTheme()
  const { selectedItem, onReset, onEdit } = props
  const details = useMemo(() => {
    if (!selectedItem) { return '' }

    const info = getMultiSelectItemInfoLabel(selectedItem)
    return (
      <>
        {info && <span className={classes.info}>{info}</span>}
        <span>{lang.emailLabel}: {selectedItem.email}</span>
      </>
    )
  }, [selectedItem])
  const name = useMemo(() => {
    return `${buildName(selectedItem)} ${(selectedItem.customerId || selectedItem.supplierId) ? `(${lang.contactPersonTitle})` : ''}`
  }, [selectedItem])

  const reset = (): void => {
    onReset?.()
  }
  const edit = (): void => {
    onEdit?.()
  }

  return (
    <div className={classes.selectedItem}>
      <div className={classes.selectedItemInfo}>
        <span className={classes.selectedItemName}>{name}</span>
        {selectedItem && <span className={classes.details}>{details}</span>}
      </div>
      {selectedItem && (
        <div className={classes.actions}>
          <SVGIcon
            svg={EditIcon}
            height='10px'
            width='10px'
            className={classes.icon}
            fill={theme.iconColorControlButton}
            onClick={edit} />
          <SVGIcon
            svg={CloseIcon}
            height='10px'
            width='10px'
            className={classes.icon}
            fill={theme.iconColorControlButton}
            onClick={reset} />
        </div>
      )}
    </div>
  )
}

export default MultiSelectActiveItem
